interface MetricCardProps {
  title: string
  value: string | number
  subtitle?: string
  trend?: {
    value: number
    isPositive: boolean
  }
}

export default function MetricCard({
  title,
  value,
  subtitle,
  trend,
}: MetricCardProps) {
  return (
    <div className="bg-noir-secondary border border-border rounded-lg p-6 hover:border-accent-cyan/30 hover:shadow-[0_0_15px_rgba(88,166,255,0.1)] transition-all duration-200">
      <dt className="text-sm font-medium text-text-secondary truncate uppercase tracking-wide">{title}</dt>
      <dd className="mt-1 flex items-baseline justify-between">
        <span className="text-2xl font-semibold text-text-primary">{value}</span>
        {trend && (
          <span
            className={`inline-flex items-baseline text-sm font-medium ${
              trend.isPositive ? 'text-verdict-approved' : 'text-verdict-rejected'
            }`}
          >
            {trend.isPositive ? '+' : ''}
            {trend.value.toFixed(1)}%
          </span>
        )}
      </dd>
      {subtitle && (
        <dd className="mt-1 text-sm text-text-secondary">{subtitle}</dd>
      )}
    </div>
  )
}
